import { Classification } from 'app/models/classification/classification';
import { MeasurementUnit } from 'app/models/measurement-unit/measurement-unit';
import { ProductProperty } from 'app/models/product/product-property/product-property';

export const PRODUCT = 'products';

export class Product {
  // Código do produto
  productId: number;

  // Código da Classificação
  classificationId: number;

  // Nome do Produto
  name: string;

  // Nome da Classificação
  clasName: string;

  //Aplicação do produto
  productApplication: string;

  //Descrição da classe da aplicação
  classApplication: string;

  // Se o produto é ontrolado por lote
  hasBatch: boolean;

  // Preço base do produto
  price: number;

  // Preço de listagem
  listPrice: number;

  // Preço de oferta
  offerPrice: number;

  // Unidade de medida padrão
  defaultMeasurementUnit: string;

  // Quantidade disponível
  quantity: number;

  // Aplicação da Classificação
  classificationApplication: string;

  // Propriedades do produto
  properties: ProductProperty[];

  // Unidades de medida do produto
  measurementUnits: MeasurementUnit[];
  
  // Classificações do Produto
  classifications: Classification[];

  // Links das imagens do produto
  links: string[];

  // TODO - listagem de lotes do produto

  // outOfLine: string;
  // departureDate: number;
  // factoryReference: string;
  // productLine: null;
  // productColumn: null;
  // forResale: string;
  // barcode: null;
  // minimumPrice: number;
  // cost: number;
  // observation: null;
  // minimumMarkup: number;
  // saleMarkup: number;
  // defaultMarkup: number;
  // weight: number;
  // packingWeight: number;
  // OldBusinessGroup: null;
  // currentBusinessGroup: null;
  // measurementUnit: number;
  // measureQuantity: number;
  // unitMeasureSelected: string;
  // index: number;
  // totalPrice: number;
  // productUnitMeasure: string;
  // measurementUnitProducts: [];
  // imagePath: string;
  // attachment: any;

  // createdAt: string;
  // updatedAt: string;

  static fromJson(json: any): Product {
    const dto = new Product();
    dto.productId = json.ID;
    dto.productApplication = json.PRODUCTAPPLICATION;
    dto.classApplication = json.CLASSAPPLICATION; 
    dto.classificationId = json.IDCLAS;
    dto.name = json.NAME;
    dto.clasName = json.CLASNAME;
    dto.hasBatch = (json.BATCH === "S"),
    dto.price = json.PRICE;
    dto.listPrice = json.LISTPRICE;
    dto.offerPrice = json.OFFERPRICE;
    dto.defaultMeasurementUnit = json.MEASUREMENTUNITDEFAULT;
    dto.quantity = json.QUANTITY;
    dto.classificationApplication = json.CLASSAPPLICATION;
    dto.properties = json.DATASHEET.map(e => ProductProperty.fromJson(e));
    dto.measurementUnits = json.MEASUREMENTUNIT.map(e => MeasurementUnit.fromJson(e));
    dto.classifications = json.CLASSIFICATIONSPRODUCT.map(e => Classification.fromJson(e));
    dto.links = json.LINKS;
    dto.measurementUnits.map((e: MeasurementUnit) => {
      json.MEASUREMENTDATAFROMCART?.forEach(element => {
        if (element.MEASUREMENTUNIT === e.measurementInitials) {
          e.cartQuantity = element.QUANTITY;
          return;
        }
      });

    });

    return dto;
  }
  
  static toJson(resource: any) {
    return {
      id: resource.id,
      createdAt: resource.createdAt,
      updatedAt: resource.updatedAt,
      hash: resource.hash,
      code: resource.code,
      classificationCode: resource.classificationCode,
      name: resource.name,
      price: resource.price,
      outOfLine: resource.outOfLine,
      departureDate: resource.departureDate,
      factoryReference: resource.factoryReference,
      productLine: resource.productLine,
      productColumn: resource.productColumn,
      forResale: resource.forResale,
      barcode: resource.barcode,
      minimumPrice: resource.minimumPrice,
      cost: resource.cost,
      observation: resource.observation,
      minimumMarkup: resource.minimumMarkup,
      saleMarkup: resource.saleMarkup,
      defaultMarkup: resource.defaultMarkup,
      weight: resource.weight,
      packingWeight: resource.packingWeight,
      OldBusinessGroup: resource.OldBusinessGroup,
      currentBusinessGroup: resource.currentBusinessGroup,
      productUnitMeasure: resource.productUnitMeasure,
      measurementUnitProducts: resource.measurementUnitProducts,
    };
  }
}
